import './Hamburger.css'
import React from 'react'

const Hamburger = props => (
  <div className={props.open ? 'Hamburger--open' : 'Hamburger'} {...props}>
    <div className="Hamburger-content">
      <div className="Hamburger-bar" />
      <div className="Hamburger-bar" />
      <div className="Hamburger-bar" />
    </div>
  </div>
)

export default Hamburger



// WEBPACK FOOTER //
// ./src/components/Hamburger.js